import type { BuilderContent } from '@builder.io/sdk'

import type { BuilderBlogModel } from '@/models'

interface Props {
  data: BuilderBlogModel
  content: BuilderContent
}

const INITIAL_REDUCE_VALUE = [[], []] as [BuilderContent[], BuilderContent[]]

export default function getBuilderSplittedBlocks({ data, content }: Props) {
  const blocksWithoutPixel = data.blocks && data.blocks.filter((block) => !block.id?.match('pixel'))
  if (blocksWithoutPixel?.length === 0 || blocksWithoutPixel === undefined) return null

  const halfBlocksQuantity = Math.ceil(blocksWithoutPixel.length / 2)

  const [firstSplittedBlocks, secondSplittedBlocks] = blocksWithoutPixel.reduce(
    ([firstGroup, secondGroup], currentBlock, index) => {
      if (index + 1 <= halfBlocksQuantity) return [[...firstGroup, currentBlock], secondGroup]

      return [firstGroup, [...secondGroup, currentBlock]]
    },
    INITIAL_REDUCE_VALUE,
  )

  const contentTop = { ...content, data: { blocks: firstSplittedBlocks } } as BuilderContent
  const contentBottom = { ...content, data: { blocks: secondSplittedBlocks } } as BuilderContent
  const splittedContent = { contentTop, contentBottom }

  return splittedContent
}
